import styled from 'styled-components';

export const StyledCountriesRadiosWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 16px 12px;
`;

export const StyledCountriesList = styled.div<{ isOpen: boolean; isTransitioning: boolean }>`
  width: 100%;
  max-height: ${({ isOpen }) => (isOpen ? '320px' : '0')};
  margin-bottom: ${({ isOpen }) => (isOpen ? '16px' : '0')};
  overflow: hidden;
  transition:
    max-height 0.3s ease-in-out,
    margin 0.3s ease-in-out;
  visibility: ${({ isOpen, isTransitioning }) => (isOpen || isTransitioning ? 'visible' : 'hidden')};
`;

export const StyledCountriesLoader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 22px 16px 22px;
`;
